var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.approvals),function(approval){return _c('ApprovalItem',{key:approval.id,attrs:{"approval":approval,"data-testid":`approvalsList-item-approval-${approval.id}`,"selected":approval.id === _vm.selectedApprovalId},on:{"click":function($event){return _vm.$emit('select', approval)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }